import { render, staticRenderFns } from "./LoyaltyFeedbackStatus.vue?vue&type=template&id=fd59fcc8&scoped=true&"
import script from "./LoyaltyFeedbackStatus.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyFeedbackStatus.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyFeedbackStatus.vue?vue&type=style&index=0&id=fd59fcc8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd59fcc8",
  null
  
)

export default component.exports